<!-- todo - consolidate this with lensPriceDetails? -->
<template>
  <div>
    <v-btn text @click="getLensData()" :loading="loading"> <slot></slot></v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="editTitleBkg text-wrap">{{
          lens_name
        }}</v-card-title>
        <v-card-subtitle class="editTitleBkg py-1"
          >Add/Edit Prices</v-card-subtitle
        >
        <v-divider class="py-1"></v-divider>
        <v-card-text class="py-2">
          <set-brand-price
            class="ma-2"
            :lens_id="lens_id"
            :lens_name="lens_name"
            :existingPrices="existingPrices"
            @dismiss="dialog = false"
            @priceDataChange="emitPrice($event)"
          ></set-brand-price>
          <!-- priceDataChange will be triggered if the user changes the price.  We'll pass this back to the parent (EyeLensPanel), which will reset this component's prop -->
        </v-card-text></v-card
      >
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import UserMixin from "@/assets/js/UserMixin";
import SetBrandPrice from "@/components/clPricesStuff/SetBrandPrice";

export default {
  name: "SetPricePopup",
  components: { SetBrandPrice },
  mixins: [UserMixin],
  props: { lens_id: null, lens_name: null, btnTitle: null },
  data: function () {
    return {
      existingPrices: null,
      dialog: false,
      loading: false,
    };
  },
  methods: {
    emitPrice($event) {
      //   alert("do something with price change! ");
      this.$emit("priceChange", $event);
      console.log("new prices", $event);
    },
    getLensData() {
      let params = null;
      if (this.auth_credentials) {
        params = this.auth_credentials;
      } else {
        alert("Please log in to use this feature");
        return;
      }

      this.loading = true;

      params.lens_id = this.lens_id;

      ApiServices.lensPrice(params)
        .then((response) => {
          //this.emitPrice(response.data);
          this.existingPrices = response.data;
          this.dialog = true;
          // update data
          // show dialog
        })
        .catch((error) => {
          console.log(error);
          this.error = "An API error occurred: " + error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {},
};
</script>

<style scoped>
.editTitleBkg {
  background-color: #ffefca;
}
</style>
